import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { apiEndpoints } from "../../services/apiConfig"; // adjust path if needed
import { sendChatOverSocket } from "../../utils/chatSocket";

export const sendChatMessage = createAsyncThunk(
    "chat/sendChatMessage",
    async (message, { rejectWithValue }) => {
        try {
            sendChatOverSocket(message);
            return { ok: true };
        } catch (error) {
            return rejectWithValue({ detail: error.message });
        }
    }
);


// chatSocket.js



export const getChatHistory = createAsyncThunk(
    "chat/getChatHistory",
    async (_, { rejectWithValue }) => {
        try {
            // Get token from localStorage
            const token = localStorage.getItem("token"); // replace "token" if your key is different

            const response = await axios.get(
                apiEndpoints.chatHistory,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                }
            );

            return response.data;
        } catch (error) {
            // Capture API or network errors
            return rejectWithValue(
                error.response?.data || { detail: "Something went wrong" }
            );
        }
    }
);




// ✅ Slice definition
const chatSlice = createSlice({
    name: "chat",
    initialState: {
        loading: false,
        success: false,
        error: null,
        sendMessageResponse: null,
        chatHistoryResponse: [],
    },
    reducers: {
        pushMessage: (state, action) => {
            state.chatHistoryResponse.push(action.payload);
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(sendChatMessage.pending, (state) => {
                state.loading = true;
                state.success = false;
                state.error = null;
            })
            .addCase(sendChatMessage.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.sendMessageResponse = action.payload;
            })
            .addCase(sendChatMessage.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.error = action.payload?.detail || "Submission failed";
            })
            .addCase(getChatHistory.pending, (state) => {
                state.loading = true;
                state.success = false;
                state.error = null;
            })
            .addCase(getChatHistory.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.chatHistoryResponse = action.payload;
            })
            .addCase(getChatHistory.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.error = action.payload?.detail || "Submission failed";
            });
    },
});

export const { pushMessage } = chatSlice.actions;
export default chatSlice.reducer;
